import React from "react";
import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { SeverityLevelEnum } from "../../../incidentLog/IncidentLogDialog.types.ts";
import { getSeverityLevelSelectOptions } from "../../../incidentLog/incidentLogDialog/CreateEditIncidentLogDialog.hooks.ts";

export interface IncidentLogSeverityFieldProps {
    severity?: SeverityLevelEnum | null;
    onChange: (severity: SeverityLevelEnum | null) => void;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogSeverityField(props: IncidentLogSeverityFieldProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalSelect
            options={getSeverityLevelSelectOptions(translateString)}
            selectedItem={props.severity ? props.severity.toString() : null}
            onChange={(severity) => props.onChange(severity ? (Number(severity) as SeverityLevelEnum) : null)}
            label={translateString("severity")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default IncidentLogSeverityField;
